import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { I18nModule } from '@spartacus/core';
import { OtpModalComponent } from './otp-modal/otp-modal.component';


@NgModule({
  declarations: [OtpModalComponent],
  imports: [
    CommonModule,
    I18nModule,
    FormsModule,
    BrowserModule,
    ReactiveFormsModule
  ],
  providers: [
  ],
})
export class OtpModalModule { }
